export enum QuestionSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
